<template>
    <div class="row">
        <div class="col-12 col-lg-12" v-if="$slots.items && $slots.items.length >= itemsPerPage">
            <div class="list-item-carousel owl-carousel owl-theme owl-single-item" ref="carouselContainer">
                <slot-component v-for="(item, index) in $slots.items" :key="index" :vnode="item" />
            </div>
        </div>

        <div :class="columnWidths" v-else v-for="item in $slots.items">
            <slot-component :vnode="item"/>
        </div>
    </div>
</template>

<script>
export default {
    components: {
        SlotComponent: {
            functional: true,
            render: (createElement, context) => context.data.attrs.vnode
        }
    },

    props: {
        itemsPerPage: {
            type: Number,
            default: 4
        },
        centerSlider:
        {
          type:Boolean,
          default:false
        },
        centerEndless:
        {
          type:Boolean,
          default:false
        },
        mini:
        {
          type:Boolean,
          default:false
        },
        mobilslice:
        {
          type:Number,
          default:2
        }

    },

    computed:
    {
        columnWidths()
        {
            const itemsPerPage = Math.min(Math.max(this.itemsPerPage, 1), 4);
            if(this.mini)
            {
              return [
                "col-6",
                itemsPerPage === 1 ? "col-sm-12" : "col-sm-6",
                "col-md-" + (12 / itemsPerPage)
              ];
            }
            return [
                "col-12",
                itemsPerPage === 1 ? "col-sm-12" : "col-sm-6",
                "col-md-" + (12 / itemsPerPage)
            ];
        }
    },

    mounted()
    {
        this.$nextTick(() =>
        {
            this.initializeCarousel();
        });
    },

    updated()
    {
        this.initializeCarousel();
    },

    methods:
    {
        initializeCarousel()
        {
            if (this.$slots.items && this.$slots.items[0].tag && (this.$slots.items.length >= this.itemsPerPage))
            {
                const $owl = $(this.$refs.carouselContainer);

                // do not render, if no html element is inside of the carousels container
                if (!$owl.children().length)
                {
                    return;
                }
                $owl.owlCarousel({
                    onInitialized(){
                        $owl.find(".owl-carousel.owl-loaded").each(function() {
                            $(this).trigger("refresh.owl.carousel");
                        });
                    },
                    items: this.itemsPerPage,
                    nav: true,
                    lazyLoad: true,
                    dots: true,
                    center:this.centerSlider,
                    loop: this.centerEndless,
                    margin:15,
                    stagePadding:5,
                    scrollPerPage : true,
                    navText: ['<span class="fa fa-angle-left"></span>','<span class="fa fa-angle-right"></span>'],
                    responsive:
                    {
                        0:      { items:this.mobilslice,slideBy:this.mobilslice },
                        600:    { items:3,slideBy:3 },
                        1000:   { items:this.itemsPerPage,slideBy:this.itemsPerPage }
                    }
                });
            }
        }
    }
}
</script>
